import { render, staticRenderFns } from "./VInlineStakeholderEditor.vue?vue&type=template&id=c86ddcd4&"
import script from "./VInlineStakeholderEditor.vue?vue&type=script&lang=js&"
export * from "./VInlineStakeholderEditor.vue?vue&type=script&lang=js&"
import style0 from "./VInlineStakeholderEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports